/**
 * Précommande : adapte les boutons de paiement accéléré Shopify (Google Pay, etc.)
 * quand le conteneur parent a data-preorder-checkout="true".
 *
 * Les boutons brandés (Google Pay, Apple Pay) utilisent un shadow DOM fermé :
 * on ne peut pas remplacer « Acheter » par « Précommander » directement.
 * On tente call-to-action="order" (souvent « Commander ») sur les web components.
 */

const BUY_NOW_SELECTORS = [
  '.shopify-payment-button__button--unbranded',
  'button.shopify-payment-button__button:not(.shopify-payment-button__button--branded)',
];

const WALLET_SELECTORS = [
  'shopify-google-pay-button',
  'shopify-apple-pay-button',
  'shopify-shop-pay-button',
];

function updatePreorderPaymentButtons(root) {
  const label = root.dataset.preorderLabel || 'Précommander';
  const moreOptionsLabel = root.dataset.preorderMoreOptions || 'Plus de moyens pour précommander';

  BUY_NOW_SELECTORS.forEach((selector) => {
    root.querySelectorAll(selector).forEach((button) => {
      const text = button.textContent.trim();
      if (text && text !== label) {
        button.textContent = label;
        button.setAttribute('aria-label', label);
      }
    });
  });

  WALLET_SELECTORS.forEach((selector) => {
    root.querySelectorAll(selector).forEach((el) => {
      const current = el.getAttribute('call-to-action');
      if (!current || current === 'buy' || current === '') {
        el.setAttribute('call-to-action', 'order');
      }
    });
  });

  root.querySelectorAll('.shopify-payment-button__more-options').forEach((link) => {
    if (link.textContent.trim() !== moreOptionsLabel) {
      link.textContent = moreOptionsLabel;
    }
  });
}

function watchPreorderCheckout(root) {
  updatePreorderPaymentButtons(root);

  const observer = new MutationObserver(() => {
    updatePreorderPaymentButtons(root);
  });

  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['call-to-action', 'recommended'],
  });

  document.addEventListener('variant:updated', () => updatePreorderPaymentButtons(root));
  document.addEventListener('variant:selected', () => updatePreorderPaymentButtons(root));
}

function init() {
  document.querySelectorAll('[data-preorder-checkout="true"]').forEach(watchPreorderCheckout);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', init);
